import React, { Component } from 'react';
import { compose } from 'react-apollo';
import { map, negate, isUndefined } from "lodash";
import styled from "styled-components";
import auth from '../../Auth';

import OfferCard from '../OfferCard/OfferCard';
import TransitionGrid from '../TransitionGrid/TransitionGrid';

const BrandsTabPane = ({ brands }) => {
  const needsAuthentication = negate(auth.isAuthenticated)();

  const items = map(brands, (brand) => (
    <OfferCard brand={brand} needsAuthentication={needsAuthentication} />
  ));

  return (
    <TransitionGrid
      items={items}
      visible={!isUndefined(brands)}
    />
  );
};

export default compose()(BrandsTabPane);
